<template>
    <div class="form-inline">
        <div class="form-group mb-2">
            <label>Número whatsapp: </label>
            <input type="text" class="form-control ml-2" v-mask="'(##) #####-####'" v-model="whatsapp"/>
        </div>        
        <button type="submit" class="btn btn-primary mb-2 ml-2" @click="saveWhatsapp">Salvar</button>
    </div>
</template>
<script>
export default {
    name: 'numero-whatsapp',
    props: {
        numero: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            whatsapp: this.numero
        }
    },
    methods: {
        saveWhatsapp() {
            const vm = this;
            $(".loading").show();
            axios.post("/whatsapp",{ numero: this.whatsapp }).then((response) => {
                $(".loading").hide();
                console.log(response.data);
                $("#myProfile").modal("hide");
            }).catch(error => {
                $(".loading").hide();
                console.log("erro ao salvar.", error);
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/util/numero-whatsapp.vue